import feedbackService from '../../services/feedbackService'

class FeedbackController {
  sendFeedback = feedbackService.sendFeedback

  fetchFeedbackTypes = feedbackService.fetchFeedbackTypes

}

export default new FeedbackController()



// WEBPACK FOOTER //
// ../src/controllers/feedbackController/feedbackController.js